var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"icon",class:_vm.additionalClasses,style:({
        fontSize: (_vm.itemSize + "px"),
        lineHeight: (_vm.itemSize + "px"),
    }),on:{"click":_vm.clickHandler}})}
var staticRenderFns = []

export { render, staticRenderFns }